// The admin console's tab set and its `?tab=` parser — kept out of the component files so the router can import
// them without breaking fast refresh (the debugTabs.ts / settingsTabs.ts shape).
import type { TabDef } from "@cntrl/ui";

export type AdminTab =
  | "overview" | "applications" | "bands" | "socials" | "people" | "anomalies" | "integrations" | "api-usage" | "push"
  | "tutorials";

export const ADMIN_TABS: readonly TabDef<AdminTab>[] = [
  { key: "overview", label: "Overview" },
  { key: "applications", label: "Applications" },
  { key: "bands", label: "Bands" },
  { key: "socials", label: "Socials" },
  { key: "people", label: "People" },
  { key: "anomalies", label: "Anomalies" },
  { key: "integrations", label: "Integrations" },
  { key: "api-usage", label: "API usage" },
  { key: "push", label: "Push" },
  { key: "tutorials", label: "Tutorials" },
];

/** A `?tab=` value, or Overview for anything unrecognised. */
export function parseAdminTab(value: unknown): AdminTab {
  return ADMIN_TABS.some((t) => t.key === value) ? (value as AdminTab) : "overview";
}
